import * as yup from 'yup';

export const faqQuestionFormValidationSchema = yup.object().shape({
    question: yup.string().required().nullable(),
});
